var _g, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icono_DNI",
    "data-name": "Icono DNI",
    width: 55.079,
    height: 31.999,
    viewBox: "0 0 55.079 31.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M758.573,93.833H711.505a4,4,0,0,1-4.005-3.987V65.823a4,4,0,0,1,4.005-3.989h47.068a4,4,0,0,1,4.005,3.989V89.847A4,4,0,0,1,758.573,93.833ZM711.505,64.5a1.333,1.333,0,0,0-1.339,1.323V89.847a1.33,1.33,0,0,0,1.339,1.32h47.068a1.331,1.331,0,0,0,1.339-1.32V65.823a1.333,1.333,0,0,0-1.339-1.323Z",
    transform: "translate(-707.5 -61.834)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 10.666,
    height: 10.666,
    transform: "translate(6.667 5.335)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 18.666,
    height: 5.661,
    transform: "translate(30.666 5.335)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 42.666,
    height: 2.667,
    transform: "translate(6.667 18.668)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 42.666,
    height: 2.667,
    transform: "translate(6.667 24.001)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDni);
export default __webpack_public_path__ + "static/media/dni.2b3a804c386b5f69e95363dab636afac.svg";
export { ForwardRef as ReactComponent };